import { makeAuthPlugin } from '../api'

export default makeAuthPlugin({
  userService: 'account',
  responseEntityField: 'account',
  entityIdField: 'accountId'
})
